<template>
  <div>
    <header>
      <app-navigation>
        <h1 id="logo_monito"><a href="https://monito.com?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=nav">Monito</a></h1>
        <ul>
          <li><a href="https://www.monito.com/en/about-monito?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=nav">About us</a></li>
          <li><a href="https://www.monito.com/en/wiki/monito-account?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=nav">Alerts</a></li>
          <li><a href="https://www.monito.com/en/wiki?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=nav">Wiki</a></li>
          <li class="langage"><a href="#">EN</a></li>
        </ul>
      </app-navigation>
    
  <app-hero-section :urlBackground="urlBackground" :herotype="herotype"></app-hero-section> 

  </header>

  <main ref="main">
    <section ref="scroll_zone" >
    <section class="
      boxed
      pt-2 pl-7 pr-7 pb-10
      pl-lg-5 pr-lg-5 pb-lg-8
      pl-md-5 pr-md-5 pb-md-8
      pl-sm-3 pr-sm-3 pb-sm-7 
      mt-5 mb-5">
      <div class="color"></div>

        <h1 id="anchor01" ref="anchor01" class="f_title mt-5 mb-7 mt-2-sm mb-sm-6">How to reduce PayPal conversion fees & other tricks to save money when you exchange money</h1>
        <div class="aside_widget mb-4 mb-sm-0">
          <div class="should excellent">
            <p><span>What you should do</span><b>Use a multi-currency card like TransferWise’s Borderless Debit Card.</b> Always pay with a card that can hold the local currency of the seller, like TransferWise's Borderless Debit Card in order to avoid PayPal’s currency conversion completely.</p>
              <a target="_blank" rel="noopener" href="https://go.monito.com/transferwise-borderless??utm_source=internal&utm_medium=internal&utm_campaign=ABTestReducePaypal&utm_content=main_content_widget&link=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1101l7rC2%2Fadref%3Aukaccount%2Fpubref%3A%25COOKIE_ID_TWP%2Fdestination%3Ahttps%253A%252F%252Ftransferwise.com%252Fgb%252Fborderless%252F" class="btn_cta fw-bold f-anti f-19 ls-1">Take me to TransferWise</a>
    </div>
        </div>
        <div v-if="false" class="aside_widget">
          <div class="should bad">
            <p><span>What you should avoid</span><b>Don’t go with a high-street bank,</b> most won’t allow you to open a bank account without a proof of residency and are all around more expensive.</p>
          </div>
        </div>
        <widget-author class="mb-6 mt-3">
          <div class="portrait">
            <span class="image" style="background-image:url('https://images.prismic.io/monito%2F7924bad3-5587-466e-8147-b095f0bb33f3_francois+profile+picture.jpg?auto=compress,format&rect=0,105,1401,1401&w=200&h=200');"></span>
            <p class="name pt-sm-2"><span>Written by</span><a href="https://www.monito.com/en/wiki/francois-briod?utm_source=internal?utm_source=internal&utm_medium=internal&utm_campaign=ABTestReducePaypal&utm_content=main_content">François Briod</a></p>
            <p class="pb-sm-3 update"><span>Last updated</span>April 16, 2020</p>
          </div>
          <p class="bio mt-2 mb-2 ls-2 pl-sm-1 fw-medium mb-sm-3 f-anti">Co-Founder of Monito and money transfer expert, François has been helping Monito’s users navigate the jungle of money transfer fees, bad exchange rates and tricks for the last six years.</p>
        </widget-author>

        <p class="f_body">We’ve all been there. You’re shopping online, find what you want but you need to pay in a currency that is not your own and the transaction occurs via PayPal. When you go to check out, the fine print contains details about the PayPal conversion fees and exchange rate and gives you choice of converting the money with PayPal or the card issuer. What it does not tell you is how much money you can lose if you tick the wrong box. It’s another reason why when it comes to anything involving international currency exchanges, <a href="https://www.monito.com/en/send-money-with/paypal?utm_source=internal&utm_medium=internal&utm_campaign=ABTestReducePaypal&utm_content=main_content">never recommend PayPal</a>.</p>

        <h2 class="f_subtitle_1">The PayPal option: An example with eBay</h2>
        <p class="f_body">Say you live in France and found an item on eBay from a seller in the US. The item is listed in US dollars. When you adding in international shipping</p>
        <img src="https://images.prismic.io/monito/e6050565c9edca37e69606c42b7089dc42d65303_ebaypaypal1.jpeg" class="mt-8 mb-8 mt-6-sm"/>
        <p class="f_body">Below these details, PayPal offers you payment options. Say you decide to pay in Euros with your local Euro-currency card. You enter the details and PayPal displays the charge in Euros and the exchange rate.</p>
        <img src="https://images.prismic.io/monito/b116a01f8b9392d67bbaeb4955e7fdbe8a27dcf8_ebaypaypal2.jpeg" class="mt-8 mb-8 mt-6-sm"/>

        <p class="f_body">PayPal quotes a rate of 1 euro to 1.09 US dollars. The real mid-market exchange rate on this day is 1 euro to 1.14 US dollars, which would equal 186.60 Euros. Of course, PayPal does not spell this out clearly–it just lists the exchange rate. So unless the customer actually leaves this page and enters the details to manually check how much the real exchange rate is on that day, the customer is not actually aware the total charge is actually €8.72 above what it would cost if the currency conversion&nbsp;was done at the real&nbsp;<a href="https://www.monito.com/en/wiki/mid-market-exchange-rate">mid-market exchange rate</a>&nbsp;versus PayPal’s exchange rate.</p>

        <p class="f_body">Here’s where it gets tricky. This card payment exchange rate is the default option, but if you click the blue “More exchange rate options.” you see this screen, which again&nbsp;<strong>defaults to PayPal’s exchange rate which has a markup of 3.5%.</strong></p>
          

        <img src="https://images.prismic.io/monito/9f41a6c7ad6778accda28de0a8724bcf98b3fc16_ebaypaypal3-1.jpeg" class="mt-8 mb-8 mt-6-sm"/>
        
        <p class="f_chapo">If you switch this to the USD option, you’ll be charged at the currency conversion that your card issuer sets.</p>

        <p class="f_body"><b>The bad news: </b>most card issuer also make money from the currency conversion and charge more than the current mid-market rate, and you won’t know what that rate is until after you’ve paid.</p>

        <p class="f_body"><b>The good news: </b>most card issuers or banks will give you a better rate than what PayPal gives you.</p>

        <p class="f_body">In this case, a few days later the charge came through as €190.20. So in this instance, we saved €5.12.</p>

        <div id="anchor02" ref="anchor02"  >
          <h3 class="f_subtitle_1 mb-6">Monito’s experts recommendations</h3>
          <div class="should_content excellent mt-3">
           <h3 class="mb-2">What you should do</h3>
           <p class="f_body">Always pay with a card that can hold the local currency of the seller, like TransferWise's Borderless Debit Card in order to avoid PayPal’s currency conversion completely.</p>
           <h4 class="f_chapo">Why TransferWise Borderless Debit Card ?</h4>
           <ul class="f_body pros">
              <li>A multi-currency Mastercard debit card great for paying in foreign currencies without the hidden fees like Paypal.</li>
              <li>An account to hold up to 50 currencies and great rates to convert between them.</li>
              <li>No setup fees or monthly charges.</li>
              <li>Local bank details in the US, Eurozone, UK, Australia, New Zealand and Poland to get paid like a local.</li>
           </ul>
           <div class="center"><a target="_blank" rel="noopener" href="https://go.monito.com/transferwise-borderless?utm_source=internal&utm_medium=internal&utm_campaign=ABTestReducePaypal&utm_content=main_content&link=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1101l7rC2%2Fadref%3Aukaccount%2Fpubref%3A%25COOKIE_ID_TWP%2Fdestination%3Ahttps%253A%252F%252Ftransferwise.com%252Fgb%252Fborderless%252F" class="btn_cta fw-bold f-anti f-17 ls-1">Take me to TransferWise</a></div>
          </div>
          <div class="should_content bad mt-4">
           <h3 class="mb-2">What you should avoid</h3>
           <p class="f_body">Avoid paying with PayPals default option or in your local currency (if it differs from the seller's) to ensure you can pay as close to the mid-market exchange rate as possible, versus PayPals exchange rate.</p>
          </div>
         </div>


</section>
<section class="
      boxed
      pt-2 pl-7 pr-7 pb-10
      pl-lg-5 pr-lg-5 pb-lg-8
      pl-md-5 pr-md-5 pb-md-8
      pl-sm-3 pr-sm-3 pb-sm-7 
      mt-5 mb-0">
        <div class="color"></div>

        <h1 class="f_title mt-5 mb-7 mt-2-sm mb-sm-6">How customers can save more money with a multi-currency debit card</h1>
        <p class="f_chapo">But we could have saved more by avoiding PayPal’s currency conversion completely by paying with a card in the local currency–in other words, in the actual currency of the item that’s being sold online, in this case, US dollars. You can do this with a number of new cards and accounts that enable people to open accounts and own cards that operate in multiple currencies. Which means that you can basically be a local customer in a number of countries across various currencies.</p>

        <h2 class="f_subtitle_1">International bank accounts</h2>
        <p class="f_body">These days, there are a bunch of multi-currency or travel cards available that offer great rates to pay in foreign currency. TransferWise’s Borderless account and debit card or a Revolut card enable customers to pay in US dollars instead of Euros (for example), which equals avoiding or reducing the conversion fee charged by the bank or card issuer.</p>

        <h2 id="anchor03" ref="anchor03" class="f_subtitle_1 mt-15">TransferWise Borderless Account and Debit Card</h2>
        <p class="f_body">TransferWise Borderless account is great for travellers, freelancers, and people with lives across borders.  After opening an account online, you get:</p>
        <ul class="f_body"><li>A multi-currency Mastercard debit card great for paying in foreign currencies without the hidden fees like Paypal. </li><li>An account to hold up to 50 currencies and great rates to convert between them.</li><li>Local bank details in the US, Eurozone, UK, Australia, New Zealand and Poland to get paid like a local.</li></ul>
        <p class="f_body">So, in this case the Euros could have been uploaded from a local Euro account and converted into US dollars at the current exchange rate plus a small transparent fee. Then, we could have used the card to pay for the transaction in US dollars seamlessly. <br><br><a href="https://go.monito.com/transferwise-borderless?utm_source=internal&utm_medium=internal&utm_campaign=ABTestReducePaypal&utm_content=main_content&link=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1101l7rC2%2Fadref%3A%2Fpubref%3A%25COOKIE_ID_TWP%2Fdestination%3Ahttps%253A%252F%252Ftransferwise.com">Learn more about TransferWise's multi-currency account</a></p>

        <h2 id="anchor04" ref="anchor04" class="f_subtitle_1 mt-15">Revolut</h2>
        <p class="f_body">Another great option for reducing fees is&nbsp;<a href="https://www.monito.com/en/send-money-with/revolut?utm_source=internal&utm_medium=internal&utm_campaign=ABTestReducePaypal&utm_content=main_content_widget">Revolut</a>, which offers a debit card with the ability to spend in 150 currencies from your balance in one of the 30 currencies you can hold in your account. Customers receive several accounts including a Euro account, which means you can add money using local bank details in Euros the more you can withdraw each month. If you top up with a debit or credit card that was issued in the European Economic Area (EEA), it’s totally free. And if you top up with a non-EEA issued, you’ll be charged a fee in some cases. (In our tests uploading USD from a US debit card, we were charged a 1.67% fee).</p>

        <h2 class="f_subtitle_1 mt-15">Plan ahead and save more money</h2>
        <p class="f_body">Next time you buy something with PayPal that involves a currency exchange, take a few extra minutes and choose the right option. Or better yet, plan in advance and start saving money for all your international money transactions with a multi-currency card.  

</p>
</section>
  </section>
    <aside v-if="false" class="scroller"><div class="aside_widget"><div class="title fs-20 pl-1 pr-1 ls-1 f-anti">💡 Monito's Tip: Open a TransferWise Borderless Account
</div><p class="fs-17 lh-4 f-anti fw-medium pl-2 pr-2 pt-4">Just arrived in the UK or planning to move soon?<br/> Do you need to pay or get paid like a local but can't open a bank account without proof of address?</p><p class="fs-17 lh-4 f-anti fw-medium pl-2 pr-2 pt-4 mb-5">Open a <a target="_blank" rel="noopener" href="https://go.monito.com/transferwise-borderless?utm_source=internal&utm_medium=internal&utm_campaign=ABTestReducePaypal&utm_content=main_content_widget&link=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1101l7rC2%2Fadref%3Aukaccount%2Fpubref%3A%25COOKIE_ID_TWP%2Fdestination%3Ahttps%253A%252F%252Ftransferwise.com%252Fgb%252Fborderless%252F">TransferWise Borderless Account online</a> and get UK bank details, a multi-currency account and a debit Mastercard.</p><a target="_blank" rel="noopener" href="https://go.monito.com/transferwise-borderless?utm_campaign=ABTestBankUK&utm_source=internal&utm_medium=internal&utm_content=hero_widget&link=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1101l7rC2%2Fadref%3Aukaccount%2Fpubref%3A%25COOKIE_ID_TWP%2Fdestination%3Ahttps%253A%252F%252Ftransferwise.com%252Fgb%252Fborderless%252F" class="btn_cta fw-bold f-anti f-19 ls-1">Open your account now</a></div></aside>
<aside class="scroller">
  <div v-if="false" class="aside_widget mb-4">
    <div class="should bad">
      <p><span>What you should avoid</span><b>Use a multi-currency card like TransferWise’s Borderless Debit Card.</b> Always pay with a card that can hold the local currency of the seller, like TransferWise's Borderless Debit Card in order to avoid PayPal’s currency conversion completely.</p>
      
    </div>
  </div>
  <div class="aside_widget">
    <div class="should excellent">
      <p><span>What you should do</span><b>Use a multi-currency card like TransferWise’s Borderless Debit Card.</b> Always pay with a card that can hold the local currency of the seller, like TransferWise's Borderless Debit Card in order to avoid PayPal’s currency conversion completely.</p>
      <a target="_blank" rel="noopener" href="https://go.monito.com/transferwise-borderless?utm_source=internal&utm_medium=internal&utm_campaign=ABTestReducePaypal&utm_content=main_content_widget&link=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1101l7rC2%2Fadref%3Aukaccount%2Fpubref%3A%25COOKIE_ID_TWP%2Fdestination%3Ahttps%253A%252F%252Ftransferwise.com%252Fgb%252Fborderless%252F" class="btn_cta fw-bold f-anti f-19 ls-1">Take me to TransferWise</a>
    </div>
  </div>
  
</aside>
    <aside ref="scroll_widgets" class="scroller article_content">
      <div class="aside_widget">
        <h4 class="fw-demi-bold fs-16 pt-5 pb-1 ">Let's browse through the article</h4>
        <ul class="fw-demi-bold f-anti fs-16 pb-3 pt-0">
          <li class="active" @click="anchor01()">The PayPal option</li>
          <li @click="anchor02()">Monito’s recommendation<a target="_blank" rel="noopener" href="https://go.monito.com/transferwise-borderless?utm_source=internal&utm_medium=internal&utm_campaign=ABTestReducePaypal&utm_content=main_content_widget_content_article&link=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1101l7rC2%2Fadref%3Aukaccount%2Fpubref%3A%25COOKIE_ID_TWP%2Fdestination%3Ahttps%253A%252F%252Ftransferwise.com%252Fgb%252Fborderless%252F" class="btn_cta hide fw-bold f-anti f-19 ls-1">Open a TransferWise Borderless Account</a></li>
          <li @click="anchor03()">TransferWise</li>
          <li @click="anchor04()">Revolut</li>
        </ul>
      </div>
    </aside>
   
  </main>
    
  <widget-articles class="pt-2" :articles="articles"><h1 class="fs-28 fw-bold f-anti mb-9 mb-sm-4 mt-sm-4">This might interest you too</h1></widget-articles>
  <app-footer></app-footer>

  </div>
</template>

<script>
  import '../assets/scss/_toolbox_fonts.scss'
  import '../assets/scss/_toolbox_margin_padding.scss'
  import '../assets/scss/_toolbox_layout.scss'
  
  import Nav from './Nav.vue'
  import Hero from './Hero.vue'
  import Footer from './Footer.vue'
  import Subhero from './Subhero.vue'
  import WidgetAuthor from './WidgetAuthor.vue'
  import WidgetFeaturedBlock from './WidgetFeaturedBlock.vue'
  import WidgetFeaturedOn from './WidgetFeaturedOn.vue'
  import WidgetProviders from './WidgetProviders.vue'
  import WidgetFaq from './WidgetFaq.vue'
  import WidgetArticlesRelated from './WidgetArticlesRelated.vue'
  export default {
    data() {
      return {
        herotype :'contentpage',
        scrollingActive : true,
        anchor : '01',
        urlBackground :'https://images.prismic.io/monito/595e5e4bf13c1e6e728aceae610bb5ed7b216739_bank-londong-metro-station.jpg',
        providers : [
          {logo: 'https://assets.monito.com/en/wiki/reduce-paypal-conversion-fees-tricks-save-money-exchange-money/ab-test/public/review_ria.png',url:'ria.com',score:'5.8'},
          {logo: 'https://assets.monito.com/en/wiki/reduce-paypal-conversion-fees-tricks-save-money-exchange-money/ab-test/public/review_worldremit.png',url:'paypal.com',score:'8.3'},
          {logo: 'https://assets.monito.com/en/wiki/reduce-paypal-conversion-fees-tricks-save-money-exchange-money/ab-test/public/review_paypal.png',url:'paypal.com',score:'5.1'},
          {logo: 'https://assets.monito.com/en/wiki/reduce-paypal-conversion-fees-tricks-save-money-exchange-money/ab-test/public/review_remitly.png',url:'paypal.com',score:'7.6'},
          {logo: 'https://assets.monito.com/en/wiki/reduce-paypal-conversion-fees-tricks-save-money-exchange-money/ab-test/public/review_transferwise.png',url:'paypal.com',score:'8.8'},
          {logo: 'https://assets.monito.com/en/wiki/reduce-paypal-conversion-fees-tricks-save-money-exchange-money/ab-test/public/review_skrill.png',url:'paypal.com',score:'8.3'}
        ],
        articles : [
          { cover: 'https://images.prismic.io/monito/2c88dce81622b53cdb86db00c5c24fcde3758a11_home-office-2452806_1280.jpg',
            url:'https://www.monito.com/en/wiki/best-way-freelancers-get-paid?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=related_content',
            title:'The best way for freelancers to get paid',
            date_author:'Apr. 15, 2019  -  by François Briod'},

            { cover: 'https://images.prismic.io/monito/effa81034b062cc66ed8b15f32fd6e106112868e_buildings_usa.jpg',
            url:'https://www.monito.com/en/wiki/open-bank-account-us-even-without-proof-residency?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=related_content',
            title:'How to open a bank account online in the U.S. without proof of residency',
            date_author:'Mar. 28, 2019  -  by François Briod'},

          { cover: 'https://images.prismic.io/monito/f1e8a7c63bb75c8846f14a6ce4da502fbf2d3772_top-tips-for-digital-nomads-finance-money-transfers.png',
            url:'https://www.monito.com/en/wiki/digital-nomads-getting-finances-right?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=related_content',
            title:'Digital Nomads — Getting Your Finances Right',
            date_author:'Feb. 28, 2020  -  by François Briod'},
          
          
          { cover: 'https://images.prismic.io/monito/a56593dc-c364-433e-b8af-63bca2948b2f_denise-jans--gmtAa0Q5MI-unsplash.jpg',
            url:'https://www.monito.com/en/wiki/open-bank-account-australia-even-without-proof-residency?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=related_content',
            title:'How to open a bank account online in Australia without proof of residency',
            date_author:'Jan. 20, 2020  -  by François Briod'},
          
          { cover: '',
            url:'https://www.monito.com/en/wiki/living-in-france',
            title:'Living in France',
            date_author:'Nov. 14, 2018'},
            { cover: 'https://images.prismic.io/monito/eaee3cd7169be1fe0363a708de2e97fa4622501c_best-international-bank-accounts-for-digital-nomads-laptop-money.jpg',
            url:'https://www.monito.com/en/wiki/best-international-bank-accounts-digital-nomads?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=related_content',
            title:'The best international bank accounts for digital nomads, travelers & expats',
            date_author:'Nov. 14, 2018'},
            { cover: 'https://images.prismic.io/monito/c6446110f7fd98ea86127c6981abf32927e07f5e_toronto.jpg',
            url:'https://www.monito.com/en/wiki/open-bank-account-canada-even-without-proof-residency',
            title:'How to open a bank account in Canada without proof of residency',
            date_author:'Jul. 17, 2019  -  by François Briod'}
          
         

        ]
      }
    },
    methods : {
      handleScroll(event){
      // hauteur de la zone de scroll
      //this.scroll_zone = this.$refs.scroll_zone.clientHeight;

      var bodyRect = document.body.getBoundingClientRect(),
      container_width = this.$refs.main.clientWidth,
      aside = this.$refs.scroll_widgets.getBoundingClientRect(),
      anchor02 = this.$refs.anchor02.getBoundingClientRect(),
      anchor03 = this.$refs.anchor03.getBoundingClientRect(),
      anchor04 = this.$refs.anchor04.getBoundingClientRect(),
      scroll_zone = this.$refs.scroll_zone.getBoundingClientRect(),
      left = scroll_zone.right,
      aside_width = this.$refs.scroll_widgets.clientWidth,
      scroll_zone_width = this.$refs.scroll_zone.clientWidth,
      aside_height = this.$refs.scroll_widgets.clientHeight,
      scroll_zone_height = this.$refs.scroll_zone.clientHeight,
     

    
      
      // position top de la zone de scroll
      offset_scroll_zone = scroll_zone.top - bodyRect.top;
      var position_x_aside = scroll_zone.top - bodyRect.top;

      var bottom_main_content = (offset_scroll_zone + scroll_zone_height);
      var windows_width = window.innerWidth;


      // valeur du scoll de la page
      var y = window.scrollY;
      var debut_scroll = 0;

      if(windows_width > 980){
        this.scrollingActive = true;
      } else {
        this.scrollingActive = false;
      }


        if (this.scrollingActive == true){
            if(y > (position_x_aside - 20 + 558)){
              if(y <= (bottom_main_content - aside_height - 20)){
                this.$refs.scroll_widgets.style.position = 'fixed';
                this.$refs.scroll_widgets.style.left = left+(container_width - (scroll_zone_width + aside_width)) + 'px';
                this.$refs.scroll_widgets.style.top = 20 + 'px';
              } else {
                this.$refs.scroll_widgets.style.top = ((scroll_zone_height - aside_height)) + 'px';
                this.$refs.scroll_widgets.style.position = 'absolute';
                this.$refs.scroll_widgets.style.left = '';
              }
            } else {
              this.$refs.scroll_widgets.style.top = '558px';
              this.$refs.scroll_widgets.style.position = 'absolute';
              this.$refs.scroll_widgets.style.left = '';
            }
        } else {
              this.$refs.scroll_widgets.style.position = 'relative';
              this.$refs.scroll_widgets.style.left = '';
              this.$refs.scroll_widgets.style.top = '';
        }

        if(anchor02.top < 190 && anchor03.top > 200) {
          $(".article_content ul li").removeClass('active');
          $(".article_content ul li:nth-child(2)").addClass('active');
        } else if (anchor03.top < 200 && anchor04.top > 300) {
          $(".article_content ul li").removeClass('active');
          $(".article_content ul li:nth-child(3)").addClass('active');
        } else if (anchor04.top < 300) {
          $(".article_content ul li").removeClass('active');
          $(".article_content ul li:nth-child(4)").addClass('active');
        } else if (anchor02.top > 190 ) { 
          $(".article_content ul li").removeClass('active');
          $(".article_content ul li:nth-child(1)").addClass('active');
        } else {
          $(".article_content ul li").removeClass('active');
          $(".article_content ul li").css(({"background":""}));
          $("#anchor02").css(({"padding-right": "","background":"","left":"", "padding-left":""}));
        }

        if(anchor03.top < 200){
         $(".article_content ul li a.btn_cta").removeClass('hide');
         $(".article_content ul li a.btn_cta").addClass('anime');
        } else {
          $(".article_content ul li a.btn_cta").addClass('hide');
        }  
  
      },
      anchor01(){
        $([document.documentElement, document.body]).animate({
          scrollTop: $("#anchor01").offset().top - 40
        }, 1000);

      },
      anchor02(){
        $([document.documentElement, document.body]).animate({
          scrollTop: $("#anchor02").offset().top - 142
        }, 1000);
       
      },
      anchor03(){
        $([document.documentElement, document.body]).animate({
          scrollTop: $("#anchor03").offset().top - 40
        }, 1000);
      },
      anchor04(){
        $([document.documentElement, document.body]).animate({
          scrollTop: $("#anchor04").offset().top - 40
        }, 1000);
      }
    },  
    components: {
      'app-navigation' : Nav,
      'app-hero-section' : Hero,
      'app-subhero-section' : Subhero,
      'widget-text-featured-block' : WidgetFeaturedBlock,
      'widget-featured-on' : WidgetFeaturedOn,
      'widget-providers' : WidgetProviders,
      'widget-articles' : WidgetArticlesRelated,
      'app-footer' : Footer,
      'widget-faq' : WidgetFaq,
      'widget-author' : WidgetAuthor
    },
    created() {
      window.addEventListener('scroll', this.handleScroll);
      window.addEventListener('resize', this.handleScroll);
    }
  }
</script>

<style lang="scss">

  header .hero_element{
    margin-top: -242px!important;
  }

  .bg-transition {
    display: none;
  }

  main {
    position: relative;
    z-index: 10000;
    margin-top: -190px;


    @media ($tablet_portrait) {
        margin-top: -170px;
    }
    @media ($mobile) {
        margin-top: -150px;
    }
  }



  .scroller {
    width: 352px;
    box-sizing: border-box;
    position: absolute;
    right: 0;
    top: 132px;
  }

  

  .scroller.article_content {
    top: 558px;

    .aside_widget {
      padding: 0;
    }

    h4 {
      color: #676767;
    }
  }

  .article_content ul {
    list-style: none;
    padding-left: 0;
    margin-left: 0;

    li {
      padding: 12px 50px;
      color: #353C45; 
      cursor: pointer;
      transition: all 0.2s ease;

      a {
        background: #0CC3CA;
        text-align: center;

        &.hide {
          display: none!important;
        }

        &:hover {
          background: #17d5dc;
        }

        &.anime {
          animation-name: apparition_btn_cta;
          animation-duration: 1s;
          position: relative;

          @keyframes apparition_btn_cta {
            from {bottom: -10px; opacity: 0;}
            to {bottom: 0; opacity: 1;}
          }
        }
      }

      &:hover {
        background: #D3F5F560;
      }


      &.active {
        background: #D3F5F5;
        color: #004660;
        position: relative;
        padding-top: 24px;
        padding-bottom: 24px;
        cursor: default;

        &:after {
          content: '';
          width: 0;
          height: 0;
          border-top: 35px solid transparent;
          border-bottom: 37px solid transparent;
          border-right: 14px solid #D3F5F5;
          left: -14px;
          top: calc(50% - 35px);
          position: absolute;
        }  
      }
    }
  }

  @media ($tablet_portrait) {
    header .hero_element{
      margin-top: -142px!important;
    }
    .article_content {
      display: none;
    }
    body {
      width: 100%;
      overflow: scrollY;
    }
    main {
      width: 100%;
      header .hero_element{
    margin-top: -242px!important;
  }header .hero_element{
    margin-top: -242px!important;
  }
      h1 {
      }
    }

    .scroller {
      width: 90%;
      margin-left: 5%;
      position: relative!important;
      top: 0;
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/ReducePaypal.vue